export default function VerifyEmailPage() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-muted/10">
      <div className="w-full max-w-md p-8 space-y-6 bg-card rounded-xl shadow-lg text-center">
        <h1 className="text-2xl font-bold">Verifique seu email</h1>
        <p className="text-muted-foreground">
          Enviamos um link de confirmação para o seu email. Por favor, clique no link para ativar sua conta.
        </p>
        <p className="text-sm text-muted-foreground">
          Não recebeu o email? Verifique sua pasta de spam ou tente novamente em alguns minutos.
        </p>
      </div>
    </div>
  )
} 